import Vue from 'vue'
import App from './App'
import router from './router'

import Vuex from 'vuex'
import store from './vuex/store'
import Api from './api/index.js'
import FastClick from 'fastclick'

import RouteTransition from '@/components/vue-route-transition'
import dialogMessage from '@/components/Dialog/dialogUtil.js'
import '@/components/Toast/toast.css'
import Toast from '@/components/Toast/index'
import "./filter.js"

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.prototype.$installdialog = dialogMessage.installDialog();
Vue.prototype.$api = Api;
FastClick.attach(document.body);

Vue.use(Toast)
Vue.use(Vuex)
Vue.config.productionTip = false
Vue.use(RouteTransition)
Vue.use(VideoPlayer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js